import { render, staticRenderFns } from "./PopupSearchVirtualCompany.vue?vue&type=template&id=5b3ed54b&scoped=true"
import script from "./PopupSearchVirtualCompany.vue?vue&type=script&lang=js"
export * from "./PopupSearchVirtualCompany.vue?vue&type=script&lang=js"
import style0 from "./PopupSearchVirtualCompany.vue?vue&type=style&index=0&id=5b3ed54b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ed54b",
  null
  
)

export default component.exports